import { ENVIRONMENTS } from './Constants';

if (import.meta.env.VITE_APP_MODE === ENVIRONMENTS.PROD) {
  console.log = () => {};
}
